<template>
    <!--热词分析主体内容[[-->
    <div class="g-laboratory-padding content-wrap radar-main">
        <!--热词条[[-->
        <div class="g-laboratory-analysis-item">
            <p class="hot-word">
                <strong>'{{queryToken}}'</strong>
                热词分析
            </p>
            <a class="g-laboratory-a back-btn" href="javascript:;" @click="goBack">返回</a>
        </div>
        <!--热词条]]-->

        <!--最近日期[[-->
        <ul class="f-clearfix times-list">
            <li
                class="time"
                v-for="(item,index) in pageConf.times"
                @click="changeSelect(item)"
                :key="index"
            >
                <a
                    class="g-laboratory-a"
                    href="javascript:;"
                    :class="{'g-laboratory-a-active': item.isActive}"
                >{{ item.name }}</a>
            </li>
        </ul>
        <!--最近日期]]-->

        <!--热度指数区域[[-->
        <div class="model-block chart-wrap">
            <h4 class="model-block-title chart-wrap-title">
                热度指数
                <!--<a class="chart-link" href="javascript:;">什么是热度指数</a>-->
            </h4>
            <div id="wordDetailChart" v-loading="loadingConf.wordDetailChart"></div>
        </div>
        <!--热度指数区域]]-->

        <!--相关文章[[-->
        <div class="model-block article-wrap" v-loading="loadingConf.wordDetailArticle">
            <h4 class="model-block-title article-wrap-title">相关文章</h4>
            <ul class="articles-list">
                <li class="article" v-for="article in hotTagArticleList">
                    <h5 class="articles-name">
                        <a :href="article.url">{{article.title}}</a>
                    </h5>
                    <p class="article-keywords">{{ article.tokens }}</p>
                </li>
            </ul>
        </div>
        <!--相关文章]]-->
        <!-- 分页[[ -->
        <pagination
            v-if="paginationConf.total >0"
            :total="paginationConf.total"
            :page-size="paginationConf.pageSize"
            @change="pageChange"
            ref="pager"
        ></pagination>
        <!-- 分页]] -->
    </div>
    <!--热词分析主体内容]]-->
</template>
<style lang="scss" scoped>
@import "~Assets/sass/pages/v4/laboratory/radar.scss";
</style>

<script>
import G2 from "@antv/g2";
import pagination from "Components/v4/pagination/pagination_v4";
import { HotTagArtList, HotTagTrendData } from "Services/getData.js";
export default {
    data() {
        return {
            paginationConf: {
                total: 0,
                pageSize: 10
            },
            params: {
                pageIndex: 0,
                pageSize: 10,
                time: 3,
                token: ""
            },
            queryCount: 0, // 查询结果
            hotTagArticleList: [],
            hotTagTrendsData: [],
            queryToken: "",
            pageConf: {
                times: [
                    {
                        name: "最近三天",
                        isActive: true,
                        value: 3
                    },
                    {
                        name: "最近一周",
                        isActive: false,
                        value: 7
                    },
                    {
                        name: "最近一月",
                        isActive: false,
                        value: 30
                    }
                ]
            },
            hotTagTrendChart: null,
            loadingConf: {
                wordDetailChart: true,
                wordDetailArticle: true
            }
        };
    },
    components: {
        pagination
    },
    created() {
        let routeParam = this.$route.params;
        this.queryToken = routeParam.token;
        this.params.token = routeParam.token;
    },
    mounted() {
        if (!this.queryToken) {
            return this.$router.history.push({
                name: "v4-laboratory-radar-trend"
            });
        }
        this.getHotTagTrendData().then(() => {
            let data = this.formatChartData(this.hotTagTrendsData);
            this.drawHotTagTrendGrapic(data);
        });
        this.getHotTagArticleList();
    },
    methods: {
        changeSelect(item) {
            item.isActive = true;
            this.params.time = item.value;
            this.pageConf.times.map(i => {
                if (i.value != item.value) {
                    i.isActive = false;
                }
                return i;
            });
            this.getHotTagArticleList();
            this.reloadChart();
        },
        reloadChart() {
            this.getHotTagTrendData().then(() => {
                let data = this.formatChartData(this.hotTagTrendsData);
                this.hotTagTrendChart.changeData(data);
            });
        },
        async getHotTagArticleList() {
            this.loadingConf.wordDetailArticle = true;
            let param = this.params;
            let response = await HotTagArtList(param);
            if (response.status == 200) {
                let data = response.data;
                if (data.code == 0) {
                    this.hotTagArticleList = data.data.data;
                    this.paginationConf.total = data.data.count;
                }
            }
            this.loadingConf.wordDetailArticle = false;
        },
        async getHotTagTrendData() {
            this.loadingConf.wordDetailChart = true;
            let param = this.params;
            let response = await HotTagTrendData(param);
            if (response.status == 200) {
                let data = response.data;
                if (data.code == 0) {
                    this.hotTagTrendsData = data.data;
                    this.paginationConf.total = data.data.count;
                }
            }
            this.loadingConf.wordDetailChart = false;
        },
        goBack() {
            this.$router.go(-1);
        },
        pageChange(param) {
            // this.params.pageSize = param.pageSize; // 发送给接口的字段
            this.params.pageIndex = param.pageIndex - 1; // 发送给接口的字段
            this.getHotTagArticleList();
        },
        formatChartData(hotTagTrendsData) {
            let trends = hotTagTrendsData.trend;
            let data = [];
            for (let [d, v] of Object.entries(trends)) {
                data.push({
                    day: d,
                    value: v
                });
            }
            return data;
        },
        drawHotTagTrendGrapic(data) {
            this.hotTagTrendChart = new G2.Chart({
                container: "wordDetailChart",
                forceFit: true,
                height: 432
            });
            this.hotTagTrendChart.source(data);
            this.hotTagTrendChart.scale("value", {
                min: 0
            });
            this.hotTagTrendChart.scale("day", {
                range: [0, 1]
            });
            this.hotTagTrendChart.tooltip({
                crosshairs: {
                    type: "line"
                }
            });
            this.hotTagTrendChart
                .line()
                .position("day*value")
                .color("#FD7E28");
            this.hotTagTrendChart
                .point()
                .position("day*value")
                .size(4)
                .shape("circle")
                .style({
                    stroke: "#fff",
                    lineWidth: 1
                })
                .color("#ff9100");
            this.hotTagTrendChart.render();
            G2.track(false);
        }
    }
};
</script>
